import { render, staticRenderFns } from "./Task-total-price.vue?vue&type=template&id=29402aec&scoped=true&"
import script from "./Task-total-price.vue?vue&type=script&lang=js&"
export * from "./Task-total-price.vue?vue&type=script&lang=js&"
import style0 from "./Task-total-price.vue?vue&type=style&index=0&id=29402aec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29402aec",
  null
  
)

export default component.exports